import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=20c99562&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c99562')) {
      api.createRecord('20c99562', component.options)
    } else {
      api.reload('20c99562', component.options)
    }
    module.hot.accept("./rate.vue?vue&type=template&id=20c99562&", function () {
      api.rerender('20c99562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rate/rate.vue"
export default component.exports